import { jwtDecode } from 'jwt-decode'

export const setSessionToken = sessionToken => async dispatch => {
  try {
    if (!sessionToken) throw new Error('Session token is required')

    localStorage.setItem('authToken', sessionToken)
    const decodedTokenString = atob(sessionToken)
    const decodedToken = jwtDecode(decodedTokenString)
    // const decodedToken = JSON.parse(atob(decodedTokenString.split('.')[1]))

    dispatch({ type: 'CREATE_SESSION', payload: { rawToken: sessionToken, ...decodedToken } })
  } catch (err) {
    console.error(err)
    dispatch({ type: 'CLEAR_SESSION', payload: '' })
  }
}

export const logOut = () => async dispatch => {
  dispatch({ type: 'CLEAR_SESSION', payload: '' })
}
